/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';

import { CustomResult } from '../models/custom-result';
import { CustomResultOfAuditVm } from '../models/custom-result-of-audit-vm';
import { CustomResultOfGetLandingPageByIdDto } from '../models/custom-result-of-get-landing-page-by-id-dto';
import { CustomResultOfGetOrganizationLandingPageDto } from '../models/custom-result-of-get-organization-landing-page-dto';
import { CustomResultOfPaginatedListOfGetDescendantLandingPagesWithPaginationDto } from '../models/custom-result-of-paginated-list-of-get-descendant-landing-pages-with-pagination-dto';
import { landingPagesCreateOrganizationPr53Url } from '../fn/landing-pages/landing-pages-create-organization-pr-53-url';
import { LandingPagesCreateOrganizationPr53Url$Params } from '../fn/landing-pages/landing-pages-create-organization-pr-53-url';
import { landingPagesCreateOrUpdate } from '../fn/landing-pages/landing-pages-create-or-update';
import { LandingPagesCreateOrUpdate$Params } from '../fn/landing-pages/landing-pages-create-or-update';
import { landingPagesGetDescendantLandingPagesWithPagination } from '../fn/landing-pages/landing-pages-get-descendant-landing-pages-with-pagination';
import { LandingPagesGetDescendantLandingPagesWithPagination$Params } from '../fn/landing-pages/landing-pages-get-descendant-landing-pages-with-pagination';
import { landingPagesGetLandingPageById } from '../fn/landing-pages/landing-pages-get-landing-page-by-id';
import { LandingPagesGetLandingPageById$Params } from '../fn/landing-pages/landing-pages-get-landing-page-by-id';
import { landingPagesGetLandingPagesAudit } from '../fn/landing-pages/landing-pages-get-landing-pages-audit';
import { LandingPagesGetLandingPagesAudit$Params } from '../fn/landing-pages/landing-pages-get-landing-pages-audit';
import { landingPagesGetOrganizationLandingPage } from '../fn/landing-pages/landing-pages-get-organization-landing-page';
import { LandingPagesGetOrganizationLandingPage$Params } from '../fn/landing-pages/landing-pages-get-organization-landing-page';
import { landingPagesGetOrganizationLandingPage2 } from '../fn/landing-pages/landing-pages-get-organization-landing-page-2';
import { LandingPagesGetOrganizationLandingPage2$Params } from '../fn/landing-pages/landing-pages-get-organization-landing-page-2';
import { landingPagesUpdateLandingPageIsActive } from '../fn/landing-pages/landing-pages-update-landing-page-is-active';
import { LandingPagesUpdateLandingPageIsActive$Params } from '../fn/landing-pages/landing-pages-update-landing-page-is-active';

@Injectable({ providedIn: 'root' })
export class LandingPagesService extends BaseService {
  constructor(config: ApiConfiguration, http: HttpClient) {
    super(config, http);
  }

  /** Path part for operation `landingPagesGetLandingPagesAudit()` */
  static readonly LandingPagesGetLandingPagesAuditPath = '/LandingPages/GetLandingPagesAudit';

  /**
   * تمام لاگ های لندینگ پیج، فقط برای کاربران پیشگام.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `landingPagesGetLandingPagesAudit()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  landingPagesGetLandingPagesAudit$Response(params: LandingPagesGetLandingPagesAudit$Params, context?: HttpContext): Observable<StrictHttpResponse<CustomResultOfAuditVm>> {
    return landingPagesGetLandingPagesAudit(this.http, this.rootUrl, params, context);
  }

  /**
   * تمام لاگ های لندینگ پیج، فقط برای کاربران پیشگام.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `landingPagesGetLandingPagesAudit$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  landingPagesGetLandingPagesAudit(params: LandingPagesGetLandingPagesAudit$Params, context?: HttpContext): Observable<CustomResultOfAuditVm> {
    return this.landingPagesGetLandingPagesAudit$Response(params, context).pipe(
      map((r: StrictHttpResponse<CustomResultOfAuditVm>): CustomResultOfAuditVm => r.body)
    );
  }

  /** Path part for operation `landingPagesCreateOrganizationPr53Url()` */
  static readonly LandingPagesCreateOrganizationPr53UrlPath = '/LandingPages/CreateOrganizationPr53Url';

  /**
   * ساخت لینک کوتاه سازمان جاری
   * Pr53.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `landingPagesCreateOrganizationPr53Url()` instead.
   *
   * This method doesn't expect any request body.
   */
  landingPagesCreateOrganizationPr53Url$Response(params?: LandingPagesCreateOrganizationPr53Url$Params, context?: HttpContext): Observable<StrictHttpResponse<CustomResult>> {
    return landingPagesCreateOrganizationPr53Url(this.http, this.rootUrl, params, context);
  }

  /**
   * ساخت لینک کوتاه سازمان جاری
   * Pr53.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `landingPagesCreateOrganizationPr53Url$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  landingPagesCreateOrganizationPr53Url(params?: LandingPagesCreateOrganizationPr53Url$Params, context?: HttpContext): Observable<CustomResult> {
    return this.landingPagesCreateOrganizationPr53Url$Response(params, context).pipe(
      map((r: StrictHttpResponse<CustomResult>): CustomResult => r.body)
    );
  }

  /** Path part for operation `landingPagesCreateOrUpdate()` */
  static readonly LandingPagesCreateOrUpdatePath = '/LandingPages/CreateOrUpdate';

  /**
   * ساخت یا به روز رسانی لندینگ پیج.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `landingPagesCreateOrUpdate()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  landingPagesCreateOrUpdate$Response(params: LandingPagesCreateOrUpdate$Params, context?: HttpContext): Observable<StrictHttpResponse<CustomResult>> {
    return landingPagesCreateOrUpdate(this.http, this.rootUrl, params, context);
  }

  /**
   * ساخت یا به روز رسانی لندینگ پیج.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `landingPagesCreateOrUpdate$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  landingPagesCreateOrUpdate(params: LandingPagesCreateOrUpdate$Params, context?: HttpContext): Observable<CustomResult> {
    return this.landingPagesCreateOrUpdate$Response(params, context).pipe(
      map((r: StrictHttpResponse<CustomResult>): CustomResult => r.body)
    );
  }

  /** Path part for operation `landingPagesGetOrganizationLandingPage()` */
  static readonly LandingPagesGetOrganizationLandingPagePath = '/LandingPages/GetOrganizationLandingPage';

  /**
   * دریافت قالب و لوگوی فعال سازمان جاری برای نمایش لندینگ پیج.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `landingPagesGetOrganizationLandingPage()` instead.
   *
   * This method doesn't expect any request body.
   */
  landingPagesGetOrganizationLandingPage$Response(params?: LandingPagesGetOrganizationLandingPage$Params, context?: HttpContext): Observable<StrictHttpResponse<CustomResultOfGetOrganizationLandingPageDto>> {
    return landingPagesGetOrganizationLandingPage(this.http, this.rootUrl, params, context);
  }

  /**
   * دریافت قالب و لوگوی فعال سازمان جاری برای نمایش لندینگ پیج.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `landingPagesGetOrganizationLandingPage$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  landingPagesGetOrganizationLandingPage(params?: LandingPagesGetOrganizationLandingPage$Params, context?: HttpContext): Observable<CustomResultOfGetOrganizationLandingPageDto> {
    return this.landingPagesGetOrganizationLandingPage$Response(params, context).pipe(
      map((r: StrictHttpResponse<CustomResultOfGetOrganizationLandingPageDto>): CustomResultOfGetOrganizationLandingPageDto => r.body)
    );
  }

  /** Path part for operation `landingPagesGetOrganizationLandingPage2()` */
  static readonly LandingPagesGetOrganizationLandingPage2Path = '/LandingPages/GetOrganizationLandingPage/{organizationName}';

  /**
   * دریافت قالب و لوگوی فعال سازمان انتخاب شده برای نمایش لندینگ پیج.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `landingPagesGetOrganizationLandingPage2()` instead.
   *
   * This method doesn't expect any request body.
   */
  landingPagesGetOrganizationLandingPage2$Response(params: LandingPagesGetOrganizationLandingPage2$Params, context?: HttpContext): Observable<StrictHttpResponse<CustomResultOfGetOrganizationLandingPageDto>> {
    return landingPagesGetOrganizationLandingPage2(this.http, this.rootUrl, params, context);
  }

  /**
   * دریافت قالب و لوگوی فعال سازمان انتخاب شده برای نمایش لندینگ پیج.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `landingPagesGetOrganizationLandingPage2$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  landingPagesGetOrganizationLandingPage2(params: LandingPagesGetOrganizationLandingPage2$Params, context?: HttpContext): Observable<CustomResultOfGetOrganizationLandingPageDto> {
    return this.landingPagesGetOrganizationLandingPage2$Response(params, context).pipe(
      map((r: StrictHttpResponse<CustomResultOfGetOrganizationLandingPageDto>): CustomResultOfGetOrganizationLandingPageDto => r.body)
    );
  }

  /** Path part for operation `landingPagesGetDescendantLandingPagesWithPagination()` */
  static readonly LandingPagesGetDescendantLandingPagesWithPaginationPath = '/LandingPages/GetDescendantLandingPagesWithPagination';

  /**
   * لیست لندینگ پیج های فرزندان با صفحه بندی برای فعال یا غیر فعال کردن.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `landingPagesGetDescendantLandingPagesWithPagination()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  landingPagesGetDescendantLandingPagesWithPagination$Response(params: LandingPagesGetDescendantLandingPagesWithPagination$Params, context?: HttpContext): Observable<StrictHttpResponse<CustomResultOfPaginatedListOfGetDescendantLandingPagesWithPaginationDto>> {
    return landingPagesGetDescendantLandingPagesWithPagination(this.http, this.rootUrl, params, context);
  }

  /**
   * لیست لندینگ پیج های فرزندان با صفحه بندی برای فعال یا غیر فعال کردن.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `landingPagesGetDescendantLandingPagesWithPagination$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  landingPagesGetDescendantLandingPagesWithPagination(params: LandingPagesGetDescendantLandingPagesWithPagination$Params, context?: HttpContext): Observable<CustomResultOfPaginatedListOfGetDescendantLandingPagesWithPaginationDto> {
    return this.landingPagesGetDescendantLandingPagesWithPagination$Response(params, context).pipe(
      map((r: StrictHttpResponse<CustomResultOfPaginatedListOfGetDescendantLandingPagesWithPaginationDto>): CustomResultOfPaginatedListOfGetDescendantLandingPagesWithPaginationDto => r.body)
    );
  }

  /** Path part for operation `landingPagesGetLandingPageById()` */
  static readonly LandingPagesGetLandingPageByIdPath = '/LandingPages/GetLandingPageById';

  /**
   * دریافت لندینگ پیج با آی دی.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `landingPagesGetLandingPageById()` instead.
   *
   * This method doesn't expect any request body.
   */
  landingPagesGetLandingPageById$Response(params?: LandingPagesGetLandingPageById$Params, context?: HttpContext): Observable<StrictHttpResponse<CustomResultOfGetLandingPageByIdDto>> {
    return landingPagesGetLandingPageById(this.http, this.rootUrl, params, context);
  }

  /**
   * دریافت لندینگ پیج با آی دی.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `landingPagesGetLandingPageById$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  landingPagesGetLandingPageById(params?: LandingPagesGetLandingPageById$Params, context?: HttpContext): Observable<CustomResultOfGetLandingPageByIdDto> {
    return this.landingPagesGetLandingPageById$Response(params, context).pipe(
      map((r: StrictHttpResponse<CustomResultOfGetLandingPageByIdDto>): CustomResultOfGetLandingPageByIdDto => r.body)
    );
  }

  /** Path part for operation `landingPagesUpdateLandingPageIsActive()` */
  static readonly LandingPagesUpdateLandingPageIsActivePath = '/LandingPages/UpdateLandingPageIsActive';

  /**
   * به روز رسانی وضعیت فعال بودن لندینگ پیج.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `landingPagesUpdateLandingPageIsActive()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  landingPagesUpdateLandingPageIsActive$Response(params: LandingPagesUpdateLandingPageIsActive$Params, context?: HttpContext): Observable<StrictHttpResponse<CustomResult>> {
    return landingPagesUpdateLandingPageIsActive(this.http, this.rootUrl, params, context);
  }

  /**
   * به روز رسانی وضعیت فعال بودن لندینگ پیج.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `landingPagesUpdateLandingPageIsActive$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  landingPagesUpdateLandingPageIsActive(params: LandingPagesUpdateLandingPageIsActive$Params, context?: HttpContext): Observable<CustomResult> {
    return this.landingPagesUpdateLandingPageIsActive$Response(params, context).pipe(
      map((r: StrictHttpResponse<CustomResult>): CustomResult => r.body)
    );
  }

}
